/*
  ============================================================
  rl-theme.js — Interações e animações da identidade RL
  ============================================================

  O QUE FAZ:
  1. Intro "Bem-vindo(a)" controlada pelo scroll (section rl-hero).
  2. Header de vidro: encolhe, esconde ao descer, volta ao subir;
     pílula deslizante nos links; brilho nas pílulas; busca que
     expande; painel "Todas as seções"; menu mobile.
  3. Cortina de transição: nos links do menu. Âncoras da mesma
     página rolam com a cortina; links para outras páginas fecham
     a cortina e ela abre na página seguinte.
  4. Entradas animadas ([data-reveal]), contadores ([data-count]),
     parallax leve ([data-parallax]).
  5. Abas da vitrine (section rl-vitrine).
  6. Cursor dourado, botões magnéticos e brasas (canvas).

  ACESSIBILIDADE:
  - "Reduzir movimento" do sistema desliga intro, cortina,
    cursor, brasas e entradas animadas.
  - Painéis prendem o foco e fecham com Esc.

  EDITOR DE TEMAS:
  Escuta shopify:section:load para religar tudo quando o
  lojista edita uma section no editor.
*/
(function () {
  'use strict';

  var cfg = window.rlTheme || {};
  var d = document, html = d.documentElement;
  var $ = function (s, r) { return (r || d).querySelector(s); };
  var $$ = function (s, r) { return Array.prototype.slice.call((r || d).querySelectorAll(s)); };
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var anim = html.classList.contains('rl-anim');
  var finePointer = window.matchMedia('(pointer: fine)').matches;
  var design = d.body.classList.contains('shopify-design-mode');
  var clamp = function (v, a, b) { return Math.min(b, Math.max(a, v)); };
  var smooth = function (t) { return t * t * (3 - 2 * t); };
  var ease = function (t) { return t < .5 ? 4 * t * t * t : 1 - Math.pow(-2 * t + 2, 3) / 2; };

  var header = $('#RlHeader');

  /* ---------- Altura do header (para o conteúdo não ficar embaixo dele) ---------- */
  function measureHeader() {
    if (!header) return;
    var h = header.getBoundingClientRect().height;
    if (!header.classList.contains('is-scrolled')) html.style.setProperty('--rl-hdr-h', Math.round(h) + 'px');
  }
  measureHeader();
  window.addEventListener('resize', measureHeader);

  /* ---------- Brasas (canvas) ---------- */
  function embers(canvas, count) {
    var noop = { start: function () {}, stop: function () {} };
    if (!canvas || reduce || !canvas.getContext) return noop;
    var ctx = canvas.getContext('2d'), dpr = Math.min(2, window.devicePixelRatio || 1), W = 0, H = 0, parts = [], raf = null, running = false;
    function size() { W = canvas.clientWidth; H = canvas.clientHeight; canvas.width = W * dpr; canvas.height = H * dpr; ctx.setTransform(dpr, 0, 0, dpr, 0, 0); }
    function spawn(p, init) {
      p.x = Math.random() * W; p.y = init ? Math.random() * H : H + 10;
      p.r = Math.random() * 1.8 + .4; p.vy = Math.random() * .6 + .25; p.vx = (Math.random() - .5) * .3;
      p.life = Math.random() * .6 + .4; p.t = Math.random() * 6.28; p.hue = Math.random() < .7 ? 38 : 16;
      return p;
    }
    size(); for (var i = 0; i < count; i++) parts.push(spawn({}, true));
    function tick() {
      ctx.clearRect(0, 0, W, H);
      for (var i = 0; i < parts.length; i++) {
        var p = parts[i]; p.t += .03; p.y -= p.vy; p.x += p.vx + Math.sin(p.t) * .25;
        var a = clamp(p.y / H, 0, 1) * p.life * (.6 + Math.sin(p.t * 3) * .4);
        if (p.y < -10) spawn(p, false);
        ctx.beginPath(); ctx.arc(p.x, p.y, p.r, 0, 6.283);
        ctx.fillStyle = 'hsla(' + p.hue + ',80%,62%,' + a.toFixed(3) + ')';
        ctx.shadowBlur = 8; ctx.shadowColor = 'hsla(' + p.hue + ',90%,55%,.8)'; ctx.fill();
      }
      if (running) raf = requestAnimationFrame(tick);
    }
    window.addEventListener('resize', size);
    // pausa quando o canvas sai da tela
    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (e) { e[0].isIntersecting ? api.start() : api.stop(); }).observe(canvas);
    }
    var api = {
      start: function () { if (!running) { running = true; tick(); } },
      stop: function () { running = false; cancelAnimationFrame(raf); }
    };
    return api;
  }

  /* ---------- Intro + hero ---------- */
  var intro = null, introDone = true, introEnd = function () { return 0; };
  function initHero() {
    var hero = $('.rl-hero');
    if (!hero) { if (header) header.classList.add('is-ready'); return; }
    var stage = hero.closest('.rl-hero-stage');
    var emHero = embers($('canvas', hero), 38);
    var started = false;
    function startHero() {
      if (started) return; started = true;
      hero.classList.add('is-go');
      if (header) header.classList.add('is-ready');
      emHero.start();
      $$('[data-count]', hero).forEach(countUp);
    }
    intro = $('.rl-intro');
    if (!intro || reduce || design || !stage.classList.contains('has-intro')) {
      if (intro) intro.style.display = 'none';
      if (stage) stage.classList.remove('has-intro');
      startHero();
      return;
    }
    // intro ativa: header espera (CSS), hero fica "preso" enquanto a intro some
    introDone = false;
    introEnd = function () { return Math.ceil(window.innerHeight * 0.92) + 2; };
    var bg = $('.rl-intro__bg', intro), glass = $('.rl-intro__glass', intro), txt = $('.rl-intro__inner', intro);
    var blobs = $$('.rl-intro__blob', intro);
    var emIntro = embers($('canvas', intro), 70);
    emIntro.start();
    var sm = 0;
    function frame() {
      var p = clamp(window.scrollY / (window.innerHeight * 0.92), 0, 1);
      sm += (p - sm) * 0.14;
      if (Math.abs(p - sm) < 0.0005) sm = p;
      var e = smooth(sm);
      bg.style.filter = 'blur(' + (28 * (1 - e)).toFixed(2) + 'px) brightness(' + (.58 + .3 * e).toFixed(3) + ')';
      bg.style.transform = 'scale(' + (1.14 - .1 * e).toFixed(4) + ')';
      var gb = (16 * (1 - e)).toFixed(2);
      glass.style.backdropFilter = glass.style.webkitBackdropFilter = 'blur(' + gb + 'px) saturate(1.3)';
      glass.style.opacity = (1 - .85 * e).toFixed(3);
      blobs.forEach(function (b) { b.style.opacity = (1 - e).toFixed(3); b.style.scale = (1 + .18 * e).toFixed(3); });
      txt.style.transform = 'translateY(' + (-40 * e).toFixed(1) + 'px) scale(' + (1 - .06 * e).toFixed(4) + ')';
      txt.style.filter = 'blur(' + (6 * e).toFixed(2) + 'px)';
      txt.style.opacity = (1 - clamp(sm * 1.45, 0, 1)).toFixed(3);
      intro.style.opacity = (1 - clamp(sm * 1.12, 0, 1)).toFixed(3);
      intro.classList.toggle('is-leaving', sm > .04);
      hero.style.transform = sm < .995 ? 'scale(' + (1.05 - .05 * e).toFixed(4) + ')' : '';
      if (sm > .55) startHero();
      var done = sm >= .995;
      if (done !== introDone) {
        introDone = done;
        intro.style.display = done ? 'none' : '';
        intro.classList.toggle('is-paused', done);
        done ? emIntro.stop() : emIntro.start();
      }
      requestAnimationFrame(frame);
    }
    requestAnimationFrame(frame);
    var toHero = function () { scrollAnim(introEnd(), 1100); };
    $$('.rl-intro__skip, .rl-intro__hint', intro).forEach(function (b) { b.addEventListener('click', toHero); });
  }

  /* ---------- Header ao rolar ---------- */
  var lastY = window.scrollY;
  function onScroll() {
    if (!header) return;
    var y = window.scrollY, limit = Math.max(introEnd() - 4, 40);
    var past = y > limit;
    header.classList.toggle('is-scrolled', past);
    var busy = d.body.classList.contains('rl-locked') || (mega && mega.classList.contains('is-open')) || (search && search.classList.contains('is-open'));
    if (y < lastY - 4 || !past || busy) header.classList.remove('is-hidden');
    else if (y > lastY + 4 && y > limit + window.innerHeight * .6) header.classList.add('is-hidden');
    lastY = y;
    spy(); parallax();
  }

  /* ---------- Rolagem suave ---------- */
  function scrollAnim(to, dur) {
    return new Promise(function (res) {
      var from = window.scrollY, delta = to - from, t0 = performance.now();
      if (reduce || Math.abs(delta) < 2) { window.scrollTo(0, to); return res(); }
      (function step(now) {
        var t = clamp((now - t0) / dur, 0, 1);
        window.scrollTo(0, from + delta * ease(t));
        t < 1 ? requestAnimationFrame(step) : res();
      })(t0);
    });
  }
  function targetY(el) { return el.getBoundingClientRect().top + window.scrollY - 24; }

  /* ---------- Cortina de transição ---------- */
  var veil = $('#RlVeil'), veilIn = veil && $('.rl-veil__in', veil), veilTxt = $('#RlVeilText'), busy = false;
  var EIO = 'cubic-bezier(.7,0,.3,1)', EO = 'cubic-bezier(.16,1,.3,1)';
  var veilOn = cfg.veil !== false && !reduce && !design && veil && veil.animate;
  function veilCover(label) {
    return new Promise(function (res) {
      if (label && veilTxt) veilTxt.textContent = label;
      veil.style.clipPath = 'inset(0 0 0 0)';
      veilIn.style.opacity = '1'; veilIn.style.transform = 'none';
      veilIn.animate([{ opacity: 0, transform: 'translateY(16px)' }, { opacity: 1, transform: 'none' }], { duration: 420, delay: 260, easing: EO, fill: 'backwards' });
      veil.animate([{ clipPath: 'inset(100% 0 0 0)' }, { clipPath: 'inset(0 0 0 0)' }], { duration: 520, easing: EIO }).onfinish = res;
    });
  }
  function veilReveal(delay) {
    return new Promise(function (res) {
      veilIn.style.opacity = '0';
      veilIn.animate([{ opacity: 1, transform: 'none' }, { opacity: 0, transform: 'translateY(-12px)' }], { duration: 260, delay: delay || 0, easing: 'ease-in', fill: 'backwards' });
      veil.style.clipPath = 'inset(0 0 100% 0)';
      veil.animate([{ clipPath: 'inset(0 0 0 0)' }, { clipPath: 'inset(0 0 100% 0)' }], { duration: 640, delay: (delay || 0) + 120, easing: EIO, fill: 'backwards' }).onfinish = function () {
        veil.style.clipPath = ''; veilIn.style.transform = ''; res();
      };
    });
  }
  // chegando de outra página com a cortina fechada
  if (html.classList.contains('rl-veil-enter')) {
    try { sessionStorage.removeItem('rl-veil'); } catch (e) {}
    if (veilOn) {
      veil.style.clipPath = 'inset(0 0 0 0)';
      html.classList.remove('rl-veil-enter');
      window.addEventListener('load', function () { veilReveal(80); });
      setTimeout(function () { if (veil.style.clipPath) veilReveal(0); }, 2500);
    } else html.classList.remove('rl-veil-enter');
  }
  function replay(el) {
    var h = $('[data-reveal="lines"]', el); if (!h) return;
    h.classList.remove('is-in'); void h.offsetWidth; h.classList.add('is-in');
  }
  function goToSection(el, label) {
    if (busy) return;
    closePanels();
    var far = Math.abs(targetY(el) - window.scrollY) > window.innerHeight * 1.6;
    if (!veilOn || !far) { scrollAnim(targetY(el), 1100).then(function () { replay(el); }); return; }
    busy = true;
    veilCover(label).then(function () {
      window.scrollTo(0, targetY(el));
      setTimeout(function () { veilReveal(0).then(function () { busy = false; replay(el); }); }, 180);
    });
    setTimeout(function () { busy = false; }, 3000);
  }
  d.addEventListener('click', function (e) {
    var a = e.target.closest('a[data-rl-link], .rl-hdr a, .rl-mega a, .rl-mmenu a');
    if (!a || e.defaultPrevented || e.button !== 0 || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;
    if (a.target && a.target !== '_self') return;
    if (a.hasAttribute('data-rl-cart-open')) return;
    var url;
    try { url = new URL(a.href, location.href); } catch (err) { return; }
    if (url.origin !== location.origin) return;
    var label = (a.querySelector('b') || a).textContent.trim();
    // mesma página + âncora: rola até a seção
    if (url.pathname === location.pathname && url.hash) {
      var el = d.getElementById(decodeURIComponent(url.hash.slice(1)));
      if (el) { e.preventDefault(); goToSection(el, label); history.replaceState(null, '', url.hash); }
      return;
    }
    if (url.pathname === location.pathname && !url.hash && url.search === location.search) {
      e.preventDefault(); closePanels(); scrollAnim(intro && !introDone ? 0 : introEnd(), 1000); return;
    }
    // outra página: fecha a cortina e navega
    if (!veilOn) return;
    e.preventDefault();
    closePanels();
    try { sessionStorage.setItem('rl-veil', '1'); } catch (err2) {}
    veilCover(label).then(function () { location.href = url.href; });
  });
  window.addEventListener('pageshow', function (e) { if (e.persisted && veil) { veil.style.clipPath = ''; } });

  /* ---------- Pílula deslizante + scroll-spy ---------- */
  var navLinks = $('#RlNavLinks'), pill = $('#RlNavPill'), links = navLinks ? $$('a', navLinks) : [], current = null, spyMap = [];
  function movePill(a) {
    if (!pill) return;
    if (!a) { pill.style.opacity = 0; return; }
    pill.style.opacity = 1; pill.style.width = a.offsetWidth + 'px';
    pill.style.transform = 'translateX(' + a.offsetLeft + 'px)';
  }
  links.forEach(function (a) {
    a.addEventListener('mouseenter', function () { movePill(a); });
    a.addEventListener('focus', function () { movePill(a); });
    try {
      var u = new URL(a.href, location.href);
      if (u.pathname === location.pathname && u.hash) { var el = d.getElementById(u.hash.slice(1)); if (el) spyMap.push({ a: a, el: el }); }
    } catch (e) {}
  });
  var pageLink = navLinks ? $('a[aria-current="page"]', navLinks) : null;
  current = pageLink;
  if (navLinks) navLinks.addEventListener('mouseleave', function () { movePill(current); });
  function spy() {
    if (!spyMap.length) return;
    var mid = window.innerHeight * .4, found = null;
    spyMap.forEach(function (m) { var r = m.el.getBoundingClientRect(); if (r.top < mid && r.bottom > mid) found = m.a; });
    if (!found) found = pageLink;
    if (found !== current) {
      spyMap.forEach(function (m) { if (m.a !== pageLink) m.a.removeAttribute('aria-current'); });
      if (found && found !== pageLink) found.setAttribute('aria-current', 'true');
      current = found;
      if (!navLinks.matches(':hover')) movePill(current);
    }
  }

  /* ---------- Brilho nas pílulas de vidro ---------- */
  function sweep(el, slow) {
    var st = el.querySelector('.rl-streak'); if (!st || reduce || !st.animate) return;
    st.animate([
      { opacity: 0, transform: 'skewX(-18deg) translateX(0)' },
      { opacity: 1, offset: .35 },
      { opacity: 0, transform: 'skewX(-18deg) translateX(' + (el.offsetWidth * 1.9) + 'px)' }
    ], { duration: slow ? 900 : 700, easing: EO });
  }
  d.addEventListener('pointerover', function (e) {
    var g = e.target.closest('[data-glass]');
    if (g && !g.contains(e.relatedTarget)) sweep(g, true);
  });
  d.addEventListener('pointerdown', function (e) { var g = e.target.closest('[data-glass]'); if (g) sweep(g, false); });

  /* ---------- Busca que expande ---------- */
  var search = $('#RlSearch'), sq = $('#RlSearchQ');
  if (search && sq) {
    $('#RlSearchBtn').addEventListener('click', function () {
      if (search.classList.contains('is-open') && sq.value.trim()) { search.submit(); return; }
      search.classList.add('is-open'); setTimeout(function () { sq.focus(); }, 60);
    });
    sq.addEventListener('focus', function () { search.classList.add('is-open'); });
    search.addEventListener('focusout', function () { setTimeout(function () { if (!search.contains(d.activeElement) && !sq.value) search.classList.remove('is-open'); }, 120); });
    sq.addEventListener('keydown', function (e) { if (e.key === 'Escape') { sq.value = ''; sq.blur(); search.classList.remove('is-open'); } });
    if (sq.value) search.classList.add('is-open');
  }

  /* ---------- Painel "Todas as seções" e menu mobile ---------- */
  var mega = $('#RlMega'), megaBtn = $('#RlMegaBtn'), mmenu = $('#RlMobileMenu'), burger = $('#RlBurger');
  function setMega(on) {
    if (!mega) return;
    mega.classList.toggle('is-open', on); mega.setAttribute('aria-hidden', on ? 'false' : 'true');
    megaBtn.setAttribute('aria-expanded', on ? 'true' : 'false');
  }
  function setMenu(on) {
    if (!mmenu) return;
    mmenu.classList.toggle('is-open', on); mmenu.setAttribute('aria-hidden', on ? 'false' : 'true');
    burger.setAttribute('aria-expanded', on ? 'true' : 'false');
    d.body.classList.toggle('rl-locked', on);
    if (on) { header.classList.remove('is-hidden'); setTimeout(function () { var f = $('input,a', mmenu); if (f) f.focus({ preventScroll: true }); }, 350); }
  }
  function closePanels() { setMega(false); if (mmenu && mmenu.classList.contains('is-open')) setMenu(false); }
  if (megaBtn) megaBtn.addEventListener('click', function (e) { e.stopPropagation(); setMega(!mega.classList.contains('is-open')); });
  if (burger) burger.addEventListener('click', function () { setMenu(!mmenu.classList.contains('is-open')); });
  d.addEventListener('click', function (e) { if (mega && mega.classList.contains('is-open') && !mega.contains(e.target) && e.target !== megaBtn) setMega(false); });
  d.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape') return;
    if (mega && mega.classList.contains('is-open')) { setMega(false); megaBtn.focus(); }
    if (mmenu && mmenu.classList.contains('is-open')) { setMenu(false); burger.focus(); }
  });

  /* ---------- Entradas animadas e contadores ---------- */
  function countUp(el) {
    if (!el || el.getAttribute('data-done')) return; el.setAttribute('data-done', '1');
    var to = parseFloat(el.getAttribute('data-count')); if (isNaN(to)) return;
    var t0 = performance.now(), dur = reduce ? 0 : 1600;
    (function f(now) { var t = dur ? clamp((now - t0) / dur, 0, 1) : 1; el.textContent = Math.round(to * (1 - Math.pow(1 - t, 3))).toLocaleString('pt-BR'); if (t < 1) requestAnimationFrame(f); })(t0);
  }
  var io = null;
  function initReveal(root) {
    var els = $$('[data-reveal]', root);
    if (!anim || design || !('IntersectionObserver' in window)) {
      els.forEach(function (el) { el.classList.add('is-in'); });
      $$('[data-count]', root).forEach(countUp);
      return;
    }
    if (!io) io = new IntersectionObserver(function (ents) {
      ents.forEach(function (en) {
        if (!en.isIntersecting) return;
        en.target.classList.add('is-in');
        $$('[data-count]', en.target).forEach(countUp);
        if (en.target.hasAttribute('data-count')) countUp(en.target);
        io.unobserve(en.target);
      });
    }, { rootMargin: '0px 0px -12% 0px', threshold: .12 });
    els.forEach(function (el) { io.observe(el); });
  }

  /* ---------- Parallax leve ---------- */
  var px = [];
  function parallax() {
    if (reduce || !anim) return;
    px.forEach(function (el) {
      var r = el.parentNode.getBoundingClientRect(); if (r.bottom < 0 || r.top > window.innerHeight) return;
      var k = (r.top + r.height / 2 - window.innerHeight / 2) / window.innerHeight;
      el.style.transform = 'translateY(' + (k * -40).toFixed(1) + 'px) scale(1.1)';
    });
  }

  /* ---------- Abas da vitrine ---------- */
  function initTabs(root) {
    $$('[data-rl-tabs]', root).forEach(function (wrap) {
      var tabs = $$('[role="tab"]', wrap), tp = $('.rl-tabs__pill', wrap);
      var sec = wrap.closest('.shopify-section') || d;
      function moveTP(b) {  // traço dourado logo abaixo do nome da aba ativa (só a largura do nome)
        if (!tp || !b) return;
        var t = $('.rl-tabs__t', b) || b, own = t !== b;
        var x = b.offsetLeft + (own ? t.offsetLeft : 0), y = own ? b.offsetTop + t.offsetTop + t.offsetHeight + 4 : b.offsetTop + b.offsetHeight - tp.offsetHeight;
        tp.style.width = t.offsetWidth + 'px'; tp.style.transform = 'translate(' + x + 'px,' + y + 'px)';
      }
      tabs.forEach(function (b, i) {
        b.addEventListener('click', function () {
          select(i, true);
          if (!reduce) { b.classList.remove('is-hop'); void b.offsetWidth; b.classList.add('is-hop'); }  // pulinho ao escolher
        });
        b.addEventListener('animationend', function (e) { if (e.animationName === 'rlTabHop') b.classList.remove('is-hop'); });
        b.addEventListener('keydown', function (e) {
          var n = e.key === 'ArrowRight' ? i + 1 : e.key === 'ArrowLeft' ? i - 1 : null;
          if (n === null) return; e.preventDefault(); n = (n + tabs.length) % tabs.length; tabs[n].focus(); select(n, true);
        });
      });
      function select(i, animate) {
        tabs.forEach(function (t, j) {
          var on = i === j, panel = d.getElementById(t.getAttribute('aria-controls'));
          t.setAttribute('aria-selected', on ? 'true' : 'false'); t.tabIndex = on ? 0 : -1;
          if (panel) {
            panel.hidden = !on;
            var g = $('.rl-grid', panel);
            if (on && animate && g && !reduce) { g.classList.remove('is-swap'); void g.offsetWidth; g.classList.add('is-swap'); }
            if (on) $$('[data-reveal]', panel).forEach(function (el) { el.classList.add('is-in'); });
          }
        });
        moveTP(tabs[i]);
        requestAnimationFrame(sync);
        // muitas abas: a linha rola de lado; traz a aba escolhida para dentro da tela
        if (animate && wrap.scrollWidth > wrap.clientWidth) {
          var b = tabs[i], x = b.offsetLeft - (wrap.clientWidth - b.offsetWidth) / 2;
          wrap.scrollTo({ left: Math.max(0, x), behavior: reduce ? 'auto' : 'smooth' });
        }
      }
      var start = tabs.findIndex(function (t) { return t.getAttribute('aria-selected') === 'true'; });
      requestAnimationFrame(function () { moveTP(tabs[start < 0 ? 0 : start]); });
      // aba que começa uma linha (quando a barra quebra) fica sem o losango separador
      function markRows() { tabs.forEach(function (t, j) { t.classList.toggle('is-row-start', j > 0 && t.offsetTop !== tabs[j - 1].offsetTop); }); }
      // onda de luz: cada nome recebe um atraso conforme a posição na faixa (esquerda → direita, linha de baixo um pouco depois)
      function stagger() {
        var w = wrap.scrollWidth || 1, h = wrap.offsetHeight || 1;
        tabs.forEach(function (t) {
          var s = $('.rl-tabs__t', t); if (!s) return;
          s.style.setProperty('--sd', ((t.offsetLeft + s.offsetLeft + s.offsetWidth / 2) / w * 1.3 + t.offsetTop / h * .3).toFixed(2) + 's');
        });
      }
      // trocar de aba reinicia a animação do nome; prende todas ao mesmo relógio da página para a onda seguir em compasso
      function sync() {
        tabs.forEach(function (t) { var s = $('.rl-tabs__t', t); if (s && s.getAnimations) s.getAnimations().forEach(function (a) { a.startTime = 0; }); });
      }
      markRows(); stagger(); requestAnimationFrame(sync);

      // efeito Dock (macOS), só com mouse: o nome sob o cursor cresce e salta, os vizinhos crescem
      // menos e são empurrados para os lados, ancorados no ponto do cursor (a palavra não foge dele).
      // Tudo é calculado a partir das posições de repouso (offset* ignora transform), por linha.
      if (finePointer && !reduce) {
        var MAX = 1.34, LIFT = 11, SIG = 150, raf = 0, mx = 0, my = 0, rows = null;
        var measure = function () {
          rows = [];
          tabs.forEach(function (t) {
            var r = rows[rows.length - 1];
            if (!r || r.top !== t.offsetTop) { r = { top: t.offsetTop, h: t.offsetHeight, items: [] }; rows.push(r); }
            r.items.push({ el: t, l: t.offsetLeft, w: t.offsetWidth });
          });
        };
        var dock = function () {
          raf = 0;
          var W = wrap.clientWidth, row = null;
          rows.forEach(function (r) { if (my >= r.top - 4 && my < r.top + r.h + 4) row = r; });
          rows.forEach(function (r) {
            if (r !== row) { r.items.forEach(function (it) { it.el.style.transform = ''; it.el.classList.remove('is-hot'); }); return; }
            var its = r.items, k = 0, s = [], L = [], i;
            its.forEach(function (it, j) {
              var c = it.l + it.w / 2;
              it.f = Math.exp(-((mx - c) * (mx - c)) / (2 * SIG * SIG)); s[j] = 1 + (MAX - 1) * it.f;
              if (mx >= it.l) k = j;
            });
            // o nome sob o cursor mantém o mesmo ponto relativo debaixo dele; os demais se encostam nele
            var a = its[k], rel = Math.min(Math.max((mx - a.l) / a.w, 0), 1);
            L[k] = mx - rel * a.w * s[k];
            for (i = k + 1; i < its.length; i++) L[i] = L[i - 1] + its[i - 1].w * s[i - 1];
            for (i = k - 1; i >= 0; i--) L[i] = L[i + 1] - its[i].w * s[i];
            // não deixa a fileira escapar muito da coluna (no máximo um pouco sobre a margem)
            var last = its.length - 1, lo = L[0], hi = L[last] + its[last].w * s[last], pad = 28, sh = 0;
            if (hi - lo > W + 2 * pad) sh = W / 2 - (lo + hi) / 2;
            else if (lo < -pad) sh = -pad - lo;
            else if (hi > W + pad) sh = W + pad - hi;
            its.forEach(function (it, j) {
              var dx = L[j] + sh + it.w * s[j] / 2 - (it.l + it.w / 2);
              it.el.style.transform = 'translate(' + dx.toFixed(1) + 'px,' + (-LIFT * it.f).toFixed(1) + 'px) scale(' + s[j].toFixed(3) + ')';
              it.el.classList.toggle('is-hot', j === k);
            });
          });
        };
        wrap.addEventListener('mouseenter', function () { measure(); wrap.classList.add('is-dock'); });
        wrap.addEventListener('mousemove', function (e) {
          var bx = wrap.getBoundingClientRect();
          mx = e.clientX - bx.left + wrap.scrollLeft; my = e.clientY - bx.top;
          if (!rows) measure();
          if (!raf) raf = requestAnimationFrame(dock);
        });
        wrap.addEventListener('mouseleave', function () {
          if (raf) cancelAnimationFrame(raf);
          raf = 0; wrap.classList.remove('is-dock');
          tabs.forEach(function (t) { t.style.transform = ''; t.classList.remove('is-hot'); });
        });
        window.addEventListener('resize', function () { rows = null; });
      }
      window.addEventListener('resize', function () { markRows(); stagger(); moveTP($('[aria-selected="true"]', wrap)); });
      if (d.fonts && d.fonts.ready) d.fonts.ready.then(function () { markRows(); stagger(); moveTP($('[aria-selected="true"]', wrap)); movePill(current); });
    });
  }

  /* ---------- Botões magnéticos ---------- */
  function initMagnet(root) {
    if (!finePointer || reduce) return;
    $$('[data-magnet]', root).forEach(function (b) {
      b.addEventListener('mousemove', function (e) { var r = b.getBoundingClientRect(); b.style.transform = 'translate(' + ((e.clientX - r.left - r.width / 2) * .18).toFixed(1) + 'px,' + ((e.clientY - r.top - r.height / 2) * .28).toFixed(1) + 'px)'; });
      b.addEventListener('mouseleave', function () { b.style.transform = ''; });
    });
  }

  /* ---------- Cursor dourado ---------- */
  (function () {
    var cur = $('#RlCursor'), dot = $('#RlCursorDot'), txt = $('#RlCursorText');
    if (!cur || !finePointer || reduce || design || cfg.cursor === false) return;
    var mx = -100, my = -100, cx = -100, cy = -100;
    d.addEventListener('mousemove', function (e) { mx = e.clientX; my = e.clientY; d.body.classList.add('rl-has-cursor'); dot.style.transform = 'translate(' + mx + 'px,' + my + 'px) rotate(45deg)'; });
    d.documentElement.addEventListener('mouseleave', function () { d.body.classList.remove('rl-has-cursor'); });
    (function loop() { cx += (mx - cx) * .18; cy += (my - cy) * .18; cur.style.transform = 'translate(' + cx.toFixed(1) + 'px,' + cy.toFixed(1) + 'px)'; requestAnimationFrame(loop); })();
    d.addEventListener('mouseover', function (e) {
      var big = e.target.closest('[data-cursor]'), lk = e.target.closest('a,button,input,select,textarea,summary,[role=tab]');
      cur.classList.toggle('is-big', !!big); cur.classList.toggle('is-link', !big && !!lk);
      if (big) txt.textContent = big.getAttribute('data-cursor');
    });
  })();

  /* ---------- WhatsApp aparece depois da abertura ---------- */
  function showWa() { var w = $('#RlWa'); if (w) w.classList.add('is-on'); }
  // No celular o botão flutuante cobre o "Adicionar ao carrinho" da página de produto: sai enquanto ele está na tela
  (function () {
    var w = $('#RlWa'), buy = $('.product__buy-buttons');
    if (!w || !buy || !('IntersectionObserver' in window)) return;
    var mq = window.matchMedia('(max-width: 640px)'), seen = false;
    function sync() { w.classList.toggle('is-hide', seen && mq.matches); }
    new IntersectionObserver(function (es) { seen = es[0].isIntersecting; sync(); }).observe(buy);
    if (mq.addEventListener) mq.addEventListener('change', sync);
  })();

  /* ---------- Início ---------- */
  function initSection(root) {
    initReveal(root); initTabs(root); initMagnet(root);
    px = $$('[data-parallax], .rl-parallax');
  }
  initHero();
  initSection(d);
  setTimeout(showWa, intro && !introDone ? 2600 : 900);
  window.addEventListener('scroll', onScroll, { passive: true });
  onScroll();
  window.addEventListener('load', function () { movePill(current); measureHeader(); });

  // Editor de temas: religa a section editada
  d.addEventListener('shopify:section:load', function (e) { initSection(e.target); if ($('.rl-hero', e.target)) initHero(); measureHeader(); });
  // Conteúdo que chega depois do carregamento (ex.: produtos relacionados via fetch)
  d.addEventListener('rl:content', function (e) { initSection(e.target); });
})();
